<div [class.user-post-quality-indicators--grid]="layout === 'grid'" class="user-post-quality-indicators">
  <div *ngIf="showPeriodSelector" class="period-selector">
    <ng-select
      [clearable]="false"
      [ngModel]="period"
      [searchable]="false"
      (ngModelChange)="onPeriodChange($event)"
      class="ng-select-sm"
      bindLabel="label"
      bindValue="value"
    >
      <ng-option *ngFor="let option of periodOptions" [value]="option.value">
        {{ option.label | translate }}
      </ng-option>
    </ng-select>
  </div>

  <ng-container *ngIf="indicators$ | async as indicators; else loadingTemplate">
    <ng-container *ngIf="indicators.length > 0; else noIndicatorsTemplate">
      <div [class.indicators-container--grid]="layout === 'grid'" class="indicators-container">
        <astrobin-post-quality-indicator-pill
          *ngFor="let indicator of indicators"
          [indicator]="indicator"
          [size]="size"
        ></astrobin-post-quality-indicator-pill>
      </div>
    </ng-container>
  </ng-container>

  <ng-template #loadingTemplate>
    <div class="loading-container">
      <astrobin-loading-indicator></astrobin-loading-indicator>
    </div>
  </ng-template>

  <ng-template #noIndicatorsTemplate>
    <div *ngIf="!error" class="no-indicators text-muted">
      <span>{{ "No post quality indicators for this period" | translate }}</span>
    </div>
    <div *ngIf="error" class="error-message text-danger">
      <span>{{ "Failed to load post quality indicators" | translate }}</span>
    </div>
  </ng-template>
</div>
